/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
import React from "react";
import { useMediaQuery } from "@mui/material";
import OrganizationStructureV2 from "../../../../components/common/OrganizationStructure/OrganizationStructureV2";

function OrganisationSearch({ containerStyle, ...props }) {
  const isMobile = useMediaQuery("(max-width: 768px)");

  const styles = {
    border: "none",
    padding: "15px 18px 0px 0px",
    display: "grid",
    // ✅ 100% Dynamic: CSS automatically handles any number of children
    gridTemplateColumns: isMobile
      ? "1fr"
      : "repeat(auto-fit, minmax(150px, 1fr))",
    columnGap: isMobile ? "0px" : "6px",
    rowGap: isMobile ? "0px" : "0px",
    alignItems: "flex-start",
  };

  return (
    <OrganizationStructureV2
      showZoneLocator={false}
      showTitle={false}
      containerStyle={{ ...styles, ...containerStyle }}
      required={false}
      storeValuesInRedux
      {...props}
    />
  );
}

export default OrganisationSearch;
